import React from 'react';
import {Table, Transfer} from 'antd';

const TableTransfer = ({loading, leftColumns, rightColumns, ...restProps}) => {
    return (
        <Transfer
            {...restProps}
            showSearch
            rowKey={item => item.id || item.device_id || item.key}
            render={item => item.plateNumber}
            filterOption={(inputValue, item) =>
                item.plateNumber.toLowerCase().includes(inputValue.toLowerCase()) ||
                item.device_id.toLowerCase().includes(inputValue.toLowerCase()) ||
                item.chassisNumber.toLowerCase().includes(inputValue.toLowerCase())
            }
        >
            {({
                  direction,
                  filteredItems,
                  onItemSelect,
                  selectedKeys: listSelectedKeys,
                  disabled: listDisabled,
              }) => {
                const columns = direction === 'left' ? leftColumns : rightColumns;
                const rowSelection = {
                    selectedRowKeys: listSelectedKeys,
                    onChange: (selectedRowKeys) => {
                        const latestSelectedKey = selectedRowKeys[selectedRowKeys.length - 1];
                        const isSelected = listSelectedKeys.includes(latestSelectedKey);
                        onItemSelect(latestSelectedKey, !isSelected);
                    },
                    getCheckboxProps: item => ({
                        disabled: listDisabled,
                    }),
                };
                return (
                    <Table
                        rowSelection={rowSelection}
                        columns={columns}
                        dataSource={filteredItems.map(item => ({
                            ...item,
                            key: item.id || item.device_id || item.key,
                        }))}
                        loading={loading}
                        size="small"
                        style={{
                            pointerEvents: listDisabled ? 'none' : undefined,
                        }}
                        onRow={record => ({
                            onClick: () => {
                                if (record.disabled || listDisabled) return;
                                onItemSelect(record.key, !listSelectedKeys.includes(record.key));
                            },
                        })}
                    />
                );
            }}
        </Transfer>
    );
};

export default TableTransfer;
